import { CurrentChatContext, UserContext } from "@/components/context";
import React, { useContext } from "react";
import { UserMessage } from "@/components/mainchat/usermessage";
import { IUser } from "@/lib/types";
import { StreamingResponse } from "@/components/mainchat/streamingresponse";
import { AssistantMessage } from "@/components/mainchat/assistantmessage";

interface CurrentChatProps {
    bottomOfPage: HTMLDivElement | null;
}

export const CurrentChat = ({ bottomOfPage }: CurrentChatProps) => {
    const { currentChat, updateCurrentChat } = useContext(CurrentChatContext);
    const { user } = useContext(UserContext);

    const tryAgain = (idx: number) => () => {
        if (currentChat && (currentChat.messages.length || 0) > 0) {
            const newChat = { ...currentChat };
            newChat.messages = newChat.messages.slice(0, idx);
            newChat.timestamp = Date.now();
            updateCurrentChat(newChat);
        }
    };

    return (
        <>
            <div className={"max-w-full lg:max-w-3xl mx-auto pt-4 lg:pt-8 px-2 lg:px-8"}>
                {currentChat?.messages.map((message, idx) =>
                    user && message.role === "user" ? (
                        <div key={`chat-${idx}`}>
                            <UserMessage message={message} user={user as IUser} />
                        </div>
                    ) : (
                        <div key={`chat-${idx}`}>
                            <AssistantMessage message={message} tryAgain={tryAgain(idx)} />
                        </div>
                    )
                )}
                <StreamingResponse bottomOfPage={bottomOfPage} />
            </div>
        </>
    );
};
